export const availableLanguages = {
  AR: ['es'],
  AT: ['de'],
  ES: ['es'],
  IN: ['en'],
  NL: ['nl'],
  NZ: ['en'],
  SE: ['sv'],
  SG: ['en'],
  FI: ['fi'],
  US: ['en'],
  HK: ['en', 'zh'],
  AU: ['en'],
  GB: ['en'],
  XA: ['en'],
  XB: ['en'],
  MX: ['es'],
  DE: ['de'],
  JP: ['ja'],
  FR: ['fr'],
  TW: ['zh'],
  CA: ['en', 'fr'],
  IT: ['it'],
  NO: ['nb'],
  BE: ['fr', 'nl'],
  CH: ['de', 'fr'],
  TH: ['en', 'th'],
};

const getLocales = (languagesByCountry) => {
  const locales = [];
  Object.keys(languagesByCountry).forEach((c) => {
    languagesByCountry[c].forEach((l) => {
      locales.push(`${l}-${c}`);
    });
  });
  return locales;
};

export const supportedLocales = getLocales(availableLanguages);

const getIsSupportedLocale = (locale) => supportedLocales.indexOf(locale) !== -1;

export default getIsSupportedLocale;
